﻿import "select2";
import Switchery from "../../../../Fundraising.UI.Shared/Vendor/switchery/js/switchery";
import { OrgSearch } from "../../../../Fundraising.UI.Shared/Modules/search/OrgSearch";
import { AjaxSessionHandler } from "../../../../Fundraising.UI.Shared/Modules/account/AjaxSessionHandler";

(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Util = {};
    let switchesProcessed = false;

    // Private Variables
    const switches = [];

    const set401AjaxHandler = () => {
        const unauthorizedRedirectUrl = M2.Util.config.unauthorizedRedirectUrl;
        new AjaxSessionHandler().unauthorizedRedirect(unauthorizedRedirectUrl);
    }

    function setUserMenu() {
        var $userMenu = $('.user-menu');
        $(document).on({
            mouseenter: function () {
                $userMenu.addClass('show-menu');
            },
            mouseleave: function () {
                $userMenu.removeClass('show-menu');
            },
            touchstart: function () {
                $userMenu.addClass('show-menu');
            }
        }, '.user-menu');

        $(document).on('touchstart', 'body', function (e) {
            // If the target of the click isn't the container
            if (!$userMenu.is(e.target) && $userMenu.has(e.target).length === 0) {
                $userMenu.removeClass('show-menu');
            }
        });
    }
    function changeLanguage() {
        $(document).on("click", ".language-switcher a", function (e) {
            M2.Util.config.language = $(this).data("language");
        });     
    }
    function disableSubmission(btn) {
        // Disable the buttons immediatly
        $(btn).addClass('disabled').attr('disabled', 'disabled');
    }
    function enableSubmission(btn) {
        // Re-enable the button as we've found suggestions
        $(btn).removeClass('disabled').removeAttr('disabled');
    }
    function setVideoEmbedLinks() {
        $(".LimelightEmbeddedPlayer table a").prop("target", "_new");
    }

    function isFlashEnabled() {
        var hasFlash = false;
        try {
            /* global ActiveXObject */
            var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
            if (fo) hasFlash = true;
        }
        catch (e) {
            if (navigator.mimeTypes["application/x-shockwave-flash"] !== undefined) hasFlash = true;
        }
        return hasFlash;
    }

    function saveSwitch(key, value) {
        switches[key] = value;
    }

    function getSwitch(key) {
        return switches[key];
    }

    function setTheme() {
        const isGSA = $('body').hasClass('campaign-gsa');
        const isFunderworks = $('body').hasClass('campaign-school');
        const isWFC = $('body').hasClass('campaign-wfc'); 
        const isGivingMarket = $('body').hasClass('campaign-gm'); 
        const theme = isGSA ? "gsa" : isFunderworks ? "school" : isWFC ? "wfc" : isGivingMarket ? "gm" : "";
        M2.Util.config.theme = theme;
    }

    function displayError() {
        if ($('.error-container').children().length >= 1) {
            $('.error-container').css('display', 'block');
        }
    }

    function setTabDropDown() {
        $(document).on('click', 'nav.tabs a.active', function (e) {
            e.preventDefault();
            var $dropDownContainer = $(this).closest('nav.tabs');
            if (!$dropDownContainer.hasClass('nav-open')) $dropDownContainer.addClass('nav-open');
            else $dropDownContainer.removeClass('nav-open');
        });
    }

    function setConfigOptions() {
        // Set config options
        /* global M2_Util_language, M2_Util_pathToImages, M2_groupLabel, M2_awardNotificationHeaderText, M2_Util_unauthorizedRedirectUrl, M2_Util_awardNotificationUrl */
        if ('undefined' !== typeof M2_Util_language) M2.Util.config.language = M2_Util_language;
        if ('undefined' !== typeof M2_Util_pathToImages) M2.Util.config.pathToImages = M2_Util_pathToImages;
        if ('undefined' !== typeof M2_Util_groupLabel) M2.Util.config.groupLabel = M2_groupLabel;
        if ('undefined' !== typeof M2_Util_awardNotificationHeaderText) M2.Util.config.awardNotificationHeaderText = M2_awardNotificationHeaderText;
        if ('undefined' !== typeof M2_Util_unauthorizedRedirectUrl) M2.Util.config.unauthorizedRedirectUrl = M2_Util_unauthorizedRedirectUrl;
        if ('undefined' !== typeof M2_Util_awardNotificationUrl) M2.Util.config.awardNotificationUrl = M2_Util_awardNotificationUrl;
    }

    M2.Util = {
        config: {
            name: "M2 Fundraising Utilities",
            mediaLoaded: false,
            pathToImages: "",
            language: "en",
            groupLabel: "Troop",
            theme: "gsa",
            groupNotSelectedText: "Troop not selected",
            selectStyleWrapper: "select-wrapper",
            selectIgnoreStyleSelector: ".native-style, .hidden",
            awardNotificationHeaderText: "Congratulations!",
            switches: [],
            warningSwitches: [],
            miniSwitches: []
        },
        isMobile: {
            Android: function () {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function () {
                return (M2.Util.isMobile.Android() || M2.Util.isMobile.BlackBerry() || M2.Util.isMobile.iOS() || M2.Util.isMobile.Opera() || M2.Util.isMobile.Windows());
            }
        },
        init: function () {
            setConfigOptions();
            changeLanguage();
            setTheme();
            setTabDropDown();
            M2.Util.setChardin();
            M2.Util.activatePrint();
            displayError();
            setUserMenu();
            this.submitLimit();
            this.textAreaLimiter();
            this.setOrgSearch();
            set401AjaxHandler();
            this.setSwitches();
        },
        setSwitches: function (callback = null) {
            switchesProcessed = false;
            function filterExistingSwitches(inputs) {
                inputs = inputs.filter(function (input) {
                    return !input.hasAttribute("data-switchery");
                });
                return inputs;
            }

            const createSwitches = (switches, theme = null, classes = null) => {
                const opts = {};
                if (theme) opts.color = theme;
                if (classes) opts.className = classes;

                switches.forEach(function (html) {
                    var switchery = new Switchery(html, opts);
                    saveSwitch(html.id, switchery);
                });
            }

            const standardSwitch = filterExistingSwitches(Array.prototype.slice.call(document.querySelectorAll('.switch')));
            const warningSwitch = filterExistingSwitches(Array.prototype.slice.call(document.querySelectorAll('.switch-warning')));
            const smallSwitches = filterExistingSwitches(Array.prototype.slice.call(document.querySelectorAll('.switch-small')));   

            if (M2.Util.isIframe()) {
                const iFrameDelay = 250;
                window.setTimeout(() => {
                    createSwitches(standardSwitch);
                    createSwitches(warningSwitch, "#B33A3A", "switchery warning-switch");
                    createSwitches(smallSwitches, null, "switchery small-switch");
                    switchesProcessed = true;
                    if (callback) {
                        callback();
                    }
                }, iFrameDelay);
            } else {
                createSwitches(standardSwitch);
                createSwitches(warningSwitch, "#B33A3A", "switchery warning-switch");
                createSwitches(smallSwitches, null, "switchery small-switch");
                switchesProcessed = true;
                if (callback) {
                    callback();
                }
            }
        },
        setSwitchery: function (switchElement, checkedBool, clickEvent) {
            if ((checkedBool && !switchElement.isChecked()) || (!checkedBool && switchElement.isChecked())) {
                switchElement.setPosition(true);
                if (clickEvent) switchElement.handleOnchange(true);
            }
        },
        onSwitchesProcessed: () => {
            return new Promise((resolve) => {
                const checkSwitches = () => {
                    if (switchesProcessed) {
                        resolve();
                    } else {
                        setTimeout(checkSwitches, 50);
                    }
                };
                checkSwitches();
            });
        },
        getSwitch: function (id) {
            return getSwitch(id);
        },
        exists: function (elem) {
            if (elem.length > 0) return true;
        },
        clearSearchBox: function (target, defaultText) {
            $(target).click(function () {
                if ($(this).val() === defaultText) $(this).val('');
            });
        },
        // Set File Uploads
        uploadPhoto: function (elem) {
            var tmpURL = $($(elem).attr("data-url")).val();
            var tmpPreview = $(elem).attr("data-preview");
            var oldImageURL = $(tmpPreview).attr("src");

            $(elem).fineUploader({
                request: {
                    endpoint: tmpURL,
                    inputName: 'File'
                },
                text: {
                    uploadButton: $(elem).html()
                },
                validation: {
                    sizeLimit: 5242880
                }
            }).on('upload', function (id, name) {
                $(tmpPreview).hide().attr("src", M2.Util.config.pathToImages + "loading-bar.gif").addClass("loading");
                $(tmpPreview).fadeIn();
            }).on('complete', function (event, id, fileName, responseJSON) {
                if (responseJSON.success) {
                    $(".qq-upload-list").fadeOut();
                    var randomnumber = Math.floor(Math.random() * 11);
                    $(tmpPreview).hide().delay(400).removeClass("loading").attr("src", responseJSON.viewurl + '&' + randomnumber).fadeIn();
                    M2.Dashboard.refreshToDoList();
                } else if (responseJSON.error) {
                    $(".qq-upload-list").fadeOut();
                    $(tmpPreview).removeClass("loading").attr("src", oldImageURL);
                }
            });
        },
        showAwardNotification: function () {
            M2.Modal.create('overlay-award', M2.Util.config.awardNotificationHeaderText, M2.Util.config.awardNotificationUrl);
        },
        setChardin: function () {
            $(document).on("click", ".help-overlay", function (e) {
                e.preventDefault();
                $('body').chardinJs('start');
            });
        },
        displayLoad: function (target) {
            $(target).html("<div style='text-align: center;'><img src='" + M2.Util.config.pathToImages + "loading-bar.gif' alt='Loading' /></div>");
        },
        addCommas: function (x) {
            return x.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
        },
        successMsg: function (target) {
            if (typeof target === "undefined") target = ".message-area";
            $(target).fadeIn().delay(1800).fadeOut(500);
            //$(target).fadeIn();
        },
        activatePrint: function () {
            $(document).on("click", "a.print-report, .print", function (e) {
                e.preventDefault();
                window.print();
                return false;
            });

            $(document).on("click", "a.print-cards", function (e) {
                e.preventDefault();
                if ($(this).hasClass("inside")) {
                    window.print();
                } else {
                    $("#iframe-business-cards-overlay").get(0).contentWindow.print();

                }
            });

        },
        submitForm: function (formRef, btnRef) {
            $(formRef).validate();
            if ($(formRef).valid()) {
                disableSubmission(btnRef);
                $(formRef).submit();
            } else {
                enableSubmission(btnRef);
            }
        },
        submitLimit: function () {
            /* Multi-Submit Limiter */
            $(document).on('submit', '.submit-limit', function (e) {
                var disabledState = "disabled";
                var loadingState = "loading-dots";
                var disabledText = "Processing";
                const $submitBtn = $(this).find("button[type=submit], input[type=submit]");
                $submitBtn.addClass(disabledState);
                $submitBtn.addClass(loadingState);
                $submitBtn.html(disabledText);
                $submitBtn.val(disabledText);
                $submitBtn.attr(disabledState, disabledState);
            });
        },
        enableSubmission: function (btn) {
            enableSubmission(btn);
        },
        stopMediaPlayer: function () {
            // Stop any videos that are playing
            try {
                //Loop and Stop
                let i;
                const videoPlayers = M2.Video.getAllPlayers();
                for (var key in videoPlayers) {
                    videoPlayers[key].pause();
                }
            } catch (err) {
                console.log(err.message);
            }
        },
        getBase64Image: function (url, callback) {
            var img = new Image();
            img.src = url;

            img.onload = function () {
                var canvas = document.createElement("canvas");
                canvas.width = this.width;
                canvas.height = this.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(this, 0, 0);
                const viewData = canvas.toDataURL("image/png"); //.replace(/^data:image\/(png|jpg);base64,/, '');
                callback(viewData);
            };
        },
        tabSelectOnBegin: function (trigger) {
            if (trigger.classList.contains('active') && $(window).width() <= '992') return false;
            M2.Util.displayLoad(".tabbed-content");
        },
        textAreaLimiter: function () {
            const textAreas = document.getElementsByTagName('textarea');
            for (let i = 0; i < textAreas.length; i++) {
                const textArea = textAreas[i];
                textArea.addEventListener('keyup', function () {
                    const charsEntered = textArea.value;
                    const maxLength = textArea.maxLength;
                    const rawCharCount = charsEntered.length;
                    const adjustedCharCount = getAdjustedCharacterCount(charsEntered);

                    if (maxLength > 0) {
                        let remainingChars = maxLength - adjustedCharCount;
                        textArea.dataset.remainingCharacters = remainingChars;
                        if (remainingChars < 0) {
                            textArea.value = textArea.value.substr(0, maxLength - getNumLineBreaks(charsEntered));
                            textArea.dataset.remainingCharacters = 0;
                        }
                    }
                }, false);
            }
            function getAdjustedCharacterCount(charsEntered) {
                const numberOfLineBreaks = getNumLineBreaks(charsEntered);
                return charsEntered.length + numberOfLineBreaks;
            }

            function getNumLineBreaks(charsEntered) {
                return (charsEntered.match(/\n/g) || []).length;
            }
        },
        isIframe: function () {
            const isIframe = window.self !== window.top;
            return isIframe;
        },
        setOrgSearch: function () {
            $(".org-search").each(function (index, el) {
                const idSelector = "#" + el.id;
                const orgSelect = new OrgSearch(idSelector);
                /*
                orgSelect.onSelectSuccess = () => {
                    console.log("success");
                };
                */
            });
        },
        setStorage: function (key, value, ttl) {
            const now = Date.now();
            const item = {
                value: value,
                expiry: now + ttl,
            };
            localStorage.setItem(key, JSON.stringify(item));
        },
        getStorage: function (key) {
            const itemStr = localStorage.getItem(key);
            if (!itemStr) return null;
            const item = JSON.parse(itemStr);
            const now = Date.now();
            if (now > item.expiry) {
                localStorage.removeItem(key);
                return null;
            }
            return item.value;
        }
    };
})(jQuery);

$(function () {
    M2.Util.init();
});